var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outerContainer",staticClass:"h-full",staticStyle:{"background-color":"hsl(30, 8%, 92%)"}})}
var staticRenderFns = []

export { render, staticRenderFns }